import { atom } from "recoil";
// git 파일명 오류

export const markupSectionStore = atom<"STOCK" | "SEASON">({
  key: "markupSectionStore",
  default: "STOCK",
});

export const markupSectionRequestModalStore = atom<boolean>({
  key: "markupSectionRequestModalStore",
  default: false,
});
